import CounterpartyModel from "./CounterpartyModel";
import EmployeeModel from "./EmployeeModel";
import OrderJobModel from "./OrderJobModel";

export default class OrderJobAssigneeModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ? new Date(data.date) : new Date(1970, 0, 1);
			this.allocationPercent = data.allocationPercent ?? 0;

			if (data.job?.id) {
				this.job = new OrderJobModel(data.job);
			}

			if (data.employee?.id) {
				this.employee = new EmployeeModel(data.employee);
			}

			if (data.subcontractor?.id) {
				this.subcontractor = new CounterpartyModel(data.subcontractor);
			}

			if (data.assigneeOrder) {
				this.assigneeOrder = data.assigneeOrder;
			}
		
			if (data.scheduledDate?.length) {
				this.scheduledDate = data.scheduledDate;
			}

			if (data.scheduledEndDate?.length) {
				this.scheduledEndDate = data.scheduledEndDate;
			}

			if (data.scheduledStartTime?.length) {
				this.scheduledStartTime = data.scheduledStartTime;
			}

			if (data.scheduledEndTime?.length) {
				this.scheduledEndTime = data.scheduledEndTime;
			}

			if (data.duration) {
				this.duration = data.duration;
			}
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	allocationPercent = 0;

	/**
	 * schecuduled start date; 
	 * clr type System.Nullable<DateOnly>
	 */
	scheduledDate: string | null = null;
	/** clr type System.Nullable<DateOnly> */
	scheduledEndDate: string | null = null;
	/** clr type System.Nullable<TimeOnly> */
	scheduledStartTime: string | null = null;
	/** clr type System.Nullable<TimeOnly> */
	scheduledEndTime: string | null = null;

	duration: any | null = null;

	job: OrderJobModel | null = null;
	employee: EmployeeModel | null = null;
	subcontractor: CounterpartyModel | null = null;
	assigneeOrder = 0;
  }